// src/features/selection/selectionSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SelectOption {
  label: string;
  value: string;
}

interface SelectionState {
  selectedRepID: SelectOption | null;
  selectedOrgID: SelectOption | null;
  selectedAccountID: SelectOption | null;
  existedRow: boolean | null;
  selectedFieldData: boolean | null;
}

const initialState: SelectionState = {
  selectedRepID: null,
  selectedOrgID: null,
  selectedAccountID: null,
  existedRow: false,
  selectedFieldData: null,
};

const selectionSlice = createSlice({
  name: 'selection',
  initialState,
  reducers: {
    setSelectedRepId: (state, action: PayloadAction<SelectOption | null>) => {
      state.selectedRepID = action.payload;
    },
    setSelectedOrgId: (state, action: PayloadAction<SelectOption | null>) => {
      state.selectedOrgID = action.payload;
    },
    setSelectedAccountId: (state, action: PayloadAction<SelectOption | null>) => {
      state.selectedAccountID = action.payload;
    },
    setselectedFieldData: (state, action: PayloadAction<boolean | null>) => {
      state.selectedFieldData = action.payload;
    },
    setExistedRow: (state, action: PayloadAction<boolean | null>) => {
      console.log("previous value", state.existedRow)
      console.log("Redux: Setting existedRow to", action.payload);
      state.existedRow = action.payload;
    },
    clearSelection: (state) => {
      state.selectedRepID = null;
      state.selectedOrgID = null;
      state.selectedAccountID = null;
    },
  },
});

export const {
  setSelectedRepId,
  setSelectedOrgId,
  setSelectedAccountId,
  setselectedFieldData,
  setExistedRow,
  clearSelection,
} = selectionSlice.actions;

export default selectionSlice.reducer;